import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/services/apiClient";
import { queryKeys } from "@/services/queryClient";
import type { TurnResultOut } from "@/services/types";

/**
 * Advances a player by one month. On success, invalidates everything that
 * could have changed: player state, portfolio, loans, turn history.
 */
export function useNextTurn(playerId: number) {
  const qc = useQueryClient();
  return useMutation<TurnResultOut, Error, void>({
    mutationFn: () => api.post(`/game/${playerId}/next-turn`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.player(playerId) });
      void qc.invalidateQueries({ queryKey: queryKeys.playerPortfolio(playerId) });
      void qc.invalidateQueries({ queryKey: queryKeys.playerLoans(playerId) });
      void qc.invalidateQueries({ queryKey: queryKeys.playerHistory(playerId) });
      void qc.invalidateQueries({ queryKey: queryKeys.players });
    },
  });
}
